import { MicOff } from 'lucide-react';
import type { MicAccess } from '../audio/recorder';

/** Why the microphone can't be used here, and what to do about it. */
export function micNoteText(access: MicAccess | null): string | null {
  switch (access) {
    case 'insecure':
      return 'Recording needs a secure connection. Open the app from its https:// link to record yourself.';
    case 'unsupported':
      return "This browser can't record (some in-app browsers can't). Open the app in Safari, Chrome, Firefox or Edge to record yourself.";
    case 'denied':
      return 'The microphone is blocked for this site. To allow it: in Safari, tap aA › Website Settings › Microphone; in Chrome, tap the icon left of the address › Permissions › Microphone. Then try again.';
    default:
      return null;
  }
}

export function MicNote({ access }: { access: MicAccess | null }) {
  const text = micNoteText(access);
  if (!text) return null;
  return (
    <p className="small muted row" style={{ alignItems: 'flex-start', gap: 8 }}>
      <MicOff size={16} aria-hidden="true" style={{ flex: 'none', marginTop: 2 }} />
      <span>{text}</span>
    </p>
  );
}
